import { styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';

export const OriginalCardContainer = styled(SRoundedContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  gap: theme.spacing(3),
  padding: theme.spacing(3)
}));
